<template>
  <div class="row workstation-list justify-content-center">
    <div
      v-for="(workstation, index) in worstationsloopExternal"
      :key="index"
      class="mx-2 col-8 col-xl"
      >
      <div v-if="workstation !== 'Commandé'" class="workstation-header">
        <b> Lead Time moyen</b> : {{ workstationList[workstation].to_next_idle}}
      </div>

      <div v-if="workstation == 'Commandé'" class="workstation-header">
        <div v-for="(supplier, index) in supplierList" :key="index" class="supplier-badge">
          <div :id="supplier.uniqid">{{supplier.supplier.substring(0,4)}}</div>
          <b-tooltip v-if="supplier.supplier.length > 3" :target="supplier.uniqid">{{supplier.supplier}}</b-tooltip>
          <div>
            <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="clock" class="svg-inline--fa fa-clock fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#ffffff" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"></path></svg>
            {{ workstationList['Commandé'][supplier.supplier].to_next_idle }} 
          </div>
          <div>{{ supplier.ratio ? supplier.ratio : '0%'}}</div>
        </div>
      </div>

      <div class="workstation-card" v-bind:class="{ andon: andonLowStock && workstation === 'En Stock' }">
        <h5 class="p-4">{{workstation}}</h5>
        <div class="workstation-kanbans-number">{{ workstationList[workstation].cards.length }}</div>
      </div>

      <div v-for="(card, index) in workstationList[workstation].cards" :key="index" class="kanban-card">
        <div class="kanban-card-id d-flex justify-content-between align-items-center">
          <div>
            <b-badge v-if="card.card_index!=-1" pill variant="light">N°{{card.card_index}}</b-badge>
            <b-badge v-else pill variant="light">TMP</b-badge>
            <span>{{card.card_id}}</span>
          </div>
          <b-badge pill variant="dark">
            {{card.supplier.supplier.substring(0,3)}}
          </b-badge>
        </div>
        <div v-if="card.last_scan && isLeadtimeTooLong(workstationList[workstation].to_next_idle, card.last_scan.created_at)"
         class="kanban-lead-time andon">
         {{card.last_scan.created_for}} J</div>
        <div v-else-if="card.last_scan" class="kanban-lead-time">{{card.last_scan.created_for}} J</div>
        <div v-else class="kanban-lead-time noscan">{{displayDelay(card.created_at)}} J</div>
      </div>
      <div v-if="workstation == 'Commandé'">
        <button v-if="bLlist.length > 0" class="bl-button" @click="showBl = !showBl">
          {{ showBl ? 'Cacher' : 'Voir'}} les bons de commande
          <img v-if="!showBl" :src="require('../../../assets/chevron-down-solid.svg')" alt="">
          <img v-else :src="require('../../../assets/chevron-up-solid.svg')" alt="">
        </button>
        <div v-if="showBl" v-for="bl in bLlist" :key="bl.code" class="kanban-card">
          <div class="ml-1 align-self-center">{{bl.code}}</div>
          <div>{{bl.quantity}}</div>
          <div>{{bl.supplier_name}}</div>
          <div class="kanban-lead-time">{{bl.delivery_date}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  name: 'WorkstationList',
  props: ['workstationList', 'bLlist', 'supplierList', 'andonLowStock'],
  data () {
    return {
      worstationsloopExternal: ['En Stock', 'Attente commande', 'Commandé'],
      showBl: false,
    }
  },
  methods: {
    isLeadtimeTooLong (leadtime, lastScan) {
    },
    displayDelay (since) {
      var now = moment()
      return now.diff(moment(since), 'days');
    }
  }
  
}
</script>
<style>
.kanban-card-id .badge {
  min-width: 3.5em;
  margin-right: 0.5em;
}

.kanban-lead-time.andon {
  background-color: var(--a-red);
}

.kanban-lead-time.noscan {
  background-color: var(--a-light-black);
}

.bl-button {
  width: 100%;
  margin: 1em 0 0.5em;
  background-color: transparent;
  border: 2px solid var(--a-dark-blue);
  color: var(--a-dark-blue);
  padding: .375rem .75rem;
  font-size: 0.8rem;
  line-height: 1.5;
  border-radius: .25rem;
  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}

.bl-button:focus {
  outline: 1px solid transparent;
}

.bl-button:active {
  box-shadow: 0 0 6px var(--a-dark-blue);
}

.bl-button img {
  width: 0.8rem;
}

.external-loop .supplier-badge {
  display: flex;
  background-color: var(--a-light-blue);
  color: white;
  padding: 0 0.5em 0 0;
  border-radius: 20px;
  justify-content: space-between;
  width: fit-content;
  margin-right: 0.2em;
}

.external-loop .supplier-badge > div {
  padding: 0 0.4em;
}

.external-loop .supplier-badge > div svg{
  width: 0.8em;
  vertical-align: baseline;
}

.external-loop .supplier-badge > div:first-child {
  background-color: var(--a-dark-blue);
  border-radius: 20px;
}

.external-loop .workstation-list > div:not(:first-child) .workstation-card::before {
  top: -100%;
}

.andon {
  background-color: red;
}

@media (max-width: 576px) {
  .external-loop .workstation-list .workstation-header  {
    /*flex-direction: column;*/
    /*align-items: center;*/
  }
}
</style>



// WEBPACK FOOTER //
// src/components/andon/hippodrome/WorkstationList.vue